<template lang="pug">
section.services-line
  .container
    template(v-if="services.length", v-for="link in services")
      a.services-line__link(:href="link.href") {{ link.label[$i18n.locale] }}
</template>

<script>
export default {
  name: 'ServicesLine',
  props: {
    // links: {
    //   type: Array,
    //   default: () => ([]),
    //   required: false,
    // },
  },
  data: () => ({
    services: [],
    links: [],
  }),
  mounted() {
    const test = !global.window.location.href.match(/^https:\//);
    fetch(`https://251805.selcdn.ru/static/services/list${test ? '.test' : ''}.json`)
      .then((res) => res.json())
      .then((out) => {
        this.services = out.services.filter((e) => e.key !== this.exclude).filter((e) => e.enable);
        this.links = out.links;
      })
      .catch((e) => {
        global.console.error(e);
      });
  },
};
</script>

<style lang="scss">
.services-line {
  background-color: #fff;
  height: 70px;
  min-height: 70px;
  border-bottom: 1px solid rgb(240, 240, 240);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &__link {
    text-decoration: none;
    font-family: Inter;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgb(0, 0, 0);
    margin: 0 40px;
    transition: all .25s ease-in-out;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: rgb(0, 0, 0);
      text-decoration: underline;
    }
  }
}
</style>
